<template>
  <div class="container">
    <div class="card">
      <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      <div class="block">
        <h2>Bienvenue chez Yuzu</h2>
        <p>
          Connectez-vous à votre espace talent Yuzu pour effectuer vos
          évaluations et retrouver vos résultats.
        </p>
      </div>
      <VForm
        :button="{
          label: $t('actions.signIn'),
          class: 'primary full-size',
          hotDisabled: false,
        }"
        :displayErrors="false"
        :displayErrorsOnSubmit="true"
        :callback="submit"
      >
        <template #form-body>
          <VField
            label="Adresse e-mail"
            type="email"
            placeholder="adresse@email.com"
            name="email"
            rules="required|email"
            v-model="state.mail"
            icon="bi-at"
            :required="true"
          />
          <VField
            type="password"
            label="Mot de passe"
            placeholder="••••••••••••"
            name="password"
            rules="required|password"
            v-model="state.password"
            icon="bi-lock"
            :required="true"
          />
          <div class="checkbox-group">
            <input
              type="checkbox"
              id="remember"
              name="remember"
              v-model="state.stayConnected"
            />
            <label for="remember" v-text="$t('form.login.rememberMe')" />
          </div>
        </template>
        <template #form-error="{ errors }">
          <div
            v-if="Object.keys(errors).length > 0 || state.error"
            class="form-error small"
            v-text="getError('ERROR_AUTH_INVALID_CREDENTIALS')"
          />
        </template>
      </VForm>
      <div class="addons column">
        <router-link :to="{ name: 'game-connection-problem' }"
          >Vous n’arrivez pas à vous connecter ?</router-link
        >
        <div class="separator" />
        <div class="inline-links">
          <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank"
            >Conditions de service</a
          >
          <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank"
            >Politique de confidentialité</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { useRouter } from "vue-router";
import { getError } from "@/composables/error.js";

const router = useRouter();

const { login } = useCandidateStore();

const state = reactive({
  mail: "",
  password: "",
  stayConnected: false,
  error: null,
});

async function submit() {
  if (state.password.length < 8) {
    state.error = "ERROR_AUTH_INVALID_CREDENTIALS";
    return;
  }

  const loginAttempt = await login(state.mail, state.password);

  if (loginAttempt.token) {
    state.error = null;
    router.push({ name: "game-home" });
  } else {
    state.error = loginAttempt.key;
  }
}
</script>
